import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingAppModuleForm(props) {
  return <SpaceRoleRangeForm {...props} role="app" settingKey="app_role_setting" />;
}

export default SpacesSettingAppModuleForm;
